import { PROSPECTS_ROUTES } from '../../constants/_routes'
import prospectsTypes from '../../constants/prospectsTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const prospects_index_request = () => {
  return {
    type: prospectsTypes.index.request
  }
}

const prospects_index_success = (response) => {
  return {
    type: prospectsTypes.index.success,
    payload: response.data
  }
}

const prospects_index_failure = (messages) => {
  return {
    type: prospectsTypes.index.failure,
    payload: messages
  }
}

const prospects_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(prospects_index_request())

    // Request
    axios.get(
      PROSPECTS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( prospects_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching prospects."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( prospects_index_failure(errors))
    })
  }

}

export {
  prospects_index
}



// WEBPACK FOOTER //
// ./src/js/actions/prospects/getindex.js